module.exports = __webpack_public_path__ + "static/img/month_11th-20th_prize.2aa0c39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize/month_11th-20th_prize.png
// module id = ZaWj
// module chunks = 1